import { render, staticRenderFns } from "./deleteImei.vue?vue&type=template&id=63013ed9&"
import script from "./deleteImei.vue?vue&type=script&lang=js&"
export * from "./deleteImei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports